// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vCMsJ","top":"styles_top__F2Cnd"};